import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Constants } from 'src/app/shared/constants';
import { AuthenticationService } from '../services/authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class ModuleAccessGuard  {
  currentUserSubscription: any;
  currentUser: any;
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {
    this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
      this.currentUser = user;
    });
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if(!this.checkModulePermissions(route)){
      this.router.navigate(['/dashboard'])
      return false;
    }
    return true;
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }

  checkModulePermissions(route: ActivatedRouteSnapshot): boolean{
    const modulePermissions = Object.keys(this.currentUser.profile.Permissions);
    if(route.routeConfig.path === Constants.WaiverManagementPath){
      return modulePermissions.indexOf(Constants.WaiverManagement) !== -1;
    }
    else if(route.routeConfig.path === Constants.ClaimsPath){
      return modulePermissions.indexOf(Constants.ClaimsManagement) !== -1;
    }
    else if(route.routeConfig.path === Constants.PaymentPath){
      return modulePermissions.indexOf(Constants.PaymentManagement) !== -1;
    }
    else if(route.routeConfig.path === Constants.InsuranceManagementPath){
      return modulePermissions.indexOf(Constants.InsuranceManagement) !== -1;
    }
    else if(route.routeConfig.path === Constants.SchoolSetupPath){
      return modulePermissions.indexOf(Constants.SchoolSetup) !== -1;
    }
  }

}
